const catalogBaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;

// Keep literal URL constructors: Vite includes these verified local assets in
// the browser build, independently of older copies in catalog storage.
const bundledCatalogImages = new Map([
  ["load-icom-m510e.jpg", new URL("../../assets/web/load-icom-m510e.jpg", import.meta.url).href],
  ["batt-sok-sk12v314ph.webp", new URL("../../assets/web/batt-sok-sk12v314ph.webp", import.meta.url).href],
  ["shore-victron-multiplus-12-1200-120.webp", new URL("../../assets/web/shore-victron-multiplus-12-1200-120.webp", import.meta.url).href],
  ["load-usb-scanstrut-tile-20.webp", new URL("../../assets/web/load-usb-scanstrut-tile-20.webp", import.meta.url).href],
  ["alt-reg-balmar-mc-618.webp", new URL("../../assets/web/alt-reg-balmar-mc-618.webp", import.meta.url).href],
  ["dist-holder-gpv.webp", new URL("../../assets/web/dist-holder-gpv.webp", import.meta.url).href],
  ["dist-ctek-smartpass-120s.webp", new URL("../../assets/web/dist-ctek-smartpass-120s.webp", import.meta.url).href],
  ["load-minnkota-terrova-80.webp", new URL("../../assets/web/load-minnkota-terrova-80.webp", import.meta.url).href],
  ["dist-relay-spdt-12v.webp", new URL("../../assets/web/dist-relay-spdt-12v.webp", import.meta.url).href],
  ["load-toilet-thetford-c223-cs.webp", new URL("../../assets/web/load-toilet-thetford-c223-cs.webp", import.meta.url).href],
  ["dist-momentary-spst.webp", new URL("../../assets/web/dist-momentary-spst.webp", import.meta.url).href],
  ["dist-spdt-center-off.webp", new URL("../../assets/web/dist-spdt-center-off.webp", import.meta.url).href],
  ["dist-dpdt-center-off.webp", new URL("../../assets/web/dist-dpdt-center-off.webp", import.meta.url).href],
  ["dist-bs-5025.webp", new URL("../../assets/web/dist-bs-5025.webp", import.meta.url).href],
  ["dist-holder-mrbf.webp", new URL("../../assets/web/dist-holder-mrbf.webp", import.meta.url).href],
  ["breaker-minn-kota-mkr27.webp", new URL("../../assets/web/breaker-minn-kota-mkr27.webp", import.meta.url).href],
  ["dist-bs-5032.png", new URL("../../assets/web/dist-bs-5032.png", import.meta.url).href],
  ["batt-epoch-460.png", new URL("../../assets/web/batt-epoch-460.png", import.meta.url).href],
  ["batt-epoch-460-v2-t.webp", new URL("../../assets/web/batt-epoch-460-v2-t.webp", import.meta.url).href],
  ["solar-zamp-obsidian-100.webp", new URL("../../assets/web/solar-zamp-obsidian-100.webp", import.meta.url).href],
  ["shore-magnum-msh3012rv-l.webp", new URL("../../assets/web/shore-magnum-msh3012rv-l.webp", import.meta.url).href],
  ["monitor-magnum-me-arc50.webp", new URL("../../assets/web/monitor-magnum-me-arc50.webp", import.meta.url).href],
  ["batt-renogy-mini-core-100-2026-10-16.jpg", new URL("../../assets/web/batt-renogy-mini-core-100-2026-10-16.jpg", import.meta.url).href],
  ["dist-bs-miniswitch-5992.webp", new URL("../../assets/web/dist-bs-miniswitch-5992.webp", import.meta.url).href],
  ["mppt-renogy-rover-30.webp", new URL("../../assets/web/mppt-renogy-rover-30.webp", import.meta.url).href],
  ["mppt-renogy-rover-li-30.webp", new URL("../../assets/web/mppt-renogy-rover-li-30.webp", import.meta.url).href],
  ["mppt-victron-10020.webp", new URL("../../assets/web/mppt-victron-10020.webp", import.meta.url).href],
  ["mppt-victron-10030.webp", new URL("../../assets/web/mppt-victron-10030.webp", import.meta.url).href],
  ["dcdc-victron-orion-18.webp", new URL("../../assets/web/dcdc-victron-orion-18.webp", import.meta.url).href],
  ["dist-sterling-apd12.webp", new URL("../../assets/web/dist-sterling-apd12.webp", import.meta.url).href],
  ["batt-pylontech-us5000.webp", new URL("../../assets/web/batt-pylontech-us5000.webp", import.meta.url).href],
  ["load-chartplotter.webp", new URL("../../assets/web/load-chartplotter.webp", import.meta.url).href],
]);

/** Verified photos travel with the app so every surface shows the same model. */
export function bundledCatalogImageUrl(filename: string | undefined): string | null {
  if (!filename) return null;
  // Older saved references use the original padded WebP. Resolve them to the
  // same unchanged manufacturer JPG used by the catalog and static-page build.
  const assetFilename = filename === "batt-renogy-lfp-100.webp"
    ? "batt-renogy-mini-core-100-2026-10-16.jpg"
    : filename;
  const imageUrl = bundledCatalogImages.get(assetFilename);
  if (!imageUrl) return null;
  // SSR has no browser origin; the static-page build copies these same assets.
  return import.meta.env.SSR
    ? `https://crimp.studio/catalog-images/${encodeURIComponent(assetFilename)}`
    : imageUrl;
}

/** Resolve a public catalog image without importing the Supabase client SDK. */
export function catalogAssetUrl(filename: string | undefined): string | null {
  if (!filename) return null;
  const bundledUrl = bundledCatalogImageUrl(filename);
  if (bundledUrl) return bundledUrl;
  if (/^(https?:|data:)/i.test(filename)) return filename;
  if (catalogBaseUrl) {
    return `${catalogBaseUrl}/storage/v1/object/public/catalog-images/${filename}`;
  }
  return `/catalog-images/${encodeURIComponent(filename)}`;
}
